import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import TwoLines from '../components/home/TwoLines';

/** Home: "Two lines. One meeting." A child's line and a parent's line, drawn by scrolling, meet as the logo. */
const HomePage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <Helmet><title>{t('home.meta_title')}</title></Helmet>
      <TwoLines />
    </>
  );
};

export default HomePage;
